import React from "react";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
// import { useSelector } from "react-redux";
import PAGTWithFilters from "../../components/AllTables/PAGTWithFilters";
import { useLocation, useNavigate } from "react-router-dom";
import { BlurWrapperWithSpan } from "../../Utils/CustomComponent";
import { useDispatch } from "react-redux";
import { setSmallDoughnutTableParentTab } from "../../store/reducers/dashboardSlice";

const PieChartDetails = () => {
  // const valuesToPopulate = useSelector((state) => state.dashboard.pieSelected);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const valuesToPopulate = location?.state;

  function handleNavigation(parent) {
    dispatch(setSmallDoughnutTableParentTab(parent));
    navigate(-1);
  }

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "92vh" }}
      >
        <article className="container-fluid">
          <div className="m-5 pt-5">
            {valuesToPopulate?.title === "Loan Distribution by Investor" ? (
              <BlurWrapperWithSpan>
                <h4>{`${valuesToPopulate.title} - ${valuesToPopulate.value}`}</h4>
              </BlurWrapperWithSpan>
            ) : (
              <h4>{`${valuesToPopulate.title} - ${valuesToPopulate.value}`}</h4>
            )}
            {valuesToPopulate?.title === "Loan Distribution by Investor" ? (
              <article className="container-fluid">
                <div className="p-3 pb-0  mt-1">
                  <h6>
                    <span
                      className="linkClick"
                      role="button"
                      onClick={() => handleNavigation(valuesToPopulate.index)}
                    >
                      Back
                    </span>{" "}
                    /
                    <BlurWrapperWithSpan>
                      {valuesToPopulate.title} - {valuesToPopulate.value}
                    </BlurWrapperWithSpan>
                  </h6>
                </div>
              </article>
            ) : (
              // <BlurWrapperWithSpan>
              //   <CustomBreadCrumbs
              //     crumbs={[
              //       {
              //         title: "Dashboard",
              //         link: "/dashboard",
              //       },
              //       {
              //         title: `${valuesToPopulate.title} - ${valuesToPopulate.value}`,
              //       },
              //     ]}
              //   />
              // </BlurWrapperWithSpan>
              <article className="container-fluid">
                <div className="p-3 pb-0  mt-1">
                  <h6>
                    <span
                      className="linkClick"
                      role="button"
                      onClick={() => handleNavigation(valuesToPopulate.index)}
                    >
                      Back
                    </span>{" "}
                    /
                    <BlurWrapperWithSpan>
                      {valuesToPopulate.title} - {valuesToPopulate.value}
                    </BlurWrapperWithSpan>
                  </h6>
                </div>
              </article>
              // <CustomBreadCrumbs
              //   crumbs={[
              //     {
              //       title: "Dashboard",
              //       link: "/dashboard",
              //     },
              //     {
              //       title: `${valuesToPopulate.title} - ${valuesToPopulate.value}`,
              //     },
              //   ]}
              // />
            )}
          </div>
        </article>

        <article className="container-fluid p-5">
          <section className="row p-3 pt-0">
            <PAGTWithFilters className={"col-sm-12"} />
          </section>
        </article>
      </section>
    </div>
  );
};

export default PieChartDetails;
